import { Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import Box from "@mui/material/Box"
import { FC } from "react"

interface PageTitleProps {
  codigoVenda?: string;
  title: string;
}

const useStyles = makeStyles({
  codigoVendaText: {
    color: '#CC8F00'
  }
})

export const PageTitle: FC<PageTitleProps> = ({ title, codigoVenda }) => {
  const classes = useStyles();
  
  return (
    <Box p={2} className="page-title">
      <Box className="X12" py={2}>
        <Typography align='left' variant="h5">{title}</Typography>
        {codigoVenda && (
          <Typography align='left' variant="body2" color="textSecondary">Código da venda: <span className={classes.codigoVendaText}>#{codigoVenda}</span></Typography>
        )}
      </Box>
    </Box>
  )
}
